import WarrantyBubblesEn from "./warranty-bubbles-en.png";
import WarrantyBubblesFr from "./warranty-bubbles-fr.png";
import WarrantyHeroEn from "./warranty-hero-en.png";
import WarrantyHeroFr from "./warranty-hero-fr.png";
import LinkBackEmail from "./link-back-email.png";
import CarPlusShieldEn from "./car-plus-shield-en.png";
import CarPlusShieldFr from "./car-plus-shield-fr.png";

export {
  WarrantyBubblesEn,
  WarrantyBubblesFr,
  WarrantyHeroEn,
  WarrantyHeroFr,
  LinkBackEmail,
  CarPlusShieldEn,
  CarPlusShieldFr,
};
